export default __webpack_public_path__ + "static/media/Evil.ca87d76f.gif";